module.exports = __webpack_public_path__ + "static/media/rsz_motorbikea2.3bc678bf.png";